import {
	faChevronLeft,
	faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import './index.scss'
import { LocalStorageHelper } from '@/utils/local-storage-helper'
import { IHeader } from '@/models/IHeader'
import { INotification } from '@/models/INotification'

interface ModalProps {
	isOpen: boolean
	onClose: () => void
	children: ReactNode
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
	if (!isOpen) return null

	return createPortal(
		<section className="modal bg-white overflow-auto top-0 right-0">
			<div className="overlay"></div>
			<div className="flex content py-4 text-left px-6 w-full md:w-[480px]">
				{children}
			</div>
		</section>,
		document.getElementById('modal-root') as HTMLDivElement,
	)
}

interface NotificationProps {
	isMobile: boolean,
	backToMenu: () => void
}

export default function NotificaitonsModal({ isMobile, backToMenu }: NotificationProps) {
	const [modalVisibility, setmodalVisibility] = useState<boolean>(false)
	const [notifications, setNotifications] = useState<INotification[]>([])
	const [loading, setLoading] = useState<boolean>(false)

	const closeModal = () => {
		setmodalVisibility(false)
	}

	const backToMenuHandler = () => {
		backToMenu();
		setmodalVisibility(false)
	}

	const onNotificationsOpen = async () => {
		setmodalVisibility(true)
		const header = LocalStorageHelper.getItem<IHeader>('header-info')
		if (header?.memberId) {
			const notifications = LocalStorageHelper.getItem<INotification[]>(
				`notifications-${header.memberId}`,
			)
			if (notifications === undefined || notifications === null) {
				setLoading(true)
				setNotifications(
					[
						{
							id: 1,
							name: 'TAKE TRAINING',
							description:
								'You’ve got outstanding training for working with children. ',
							url: '/',
						},
						{
							id: 2,
							name: 'FIND OUT MORE',
							description:
								'Arcu sit sit urna porttitor aliquam odio. Tempor viverra cursus laoreet mi. Enim amet dignissim.',
							url: '/',
						},
					], // get notifications from api
				)
				setLoading(false)
			} else {
				setNotifications(notifications ?? [])
			}
		}
	}

	useEffect(() => {
		if (modalVisibility) {
			document.body.classList.add('overflow-hidden')
		} else {
			document.body.classList.remove('overflow-hidden')
		}
	}, [modalVisibility])

	return (
		<div>
			{isMobile ? (
				<a
					onClick={onNotificationsOpen}
					className="flex"
				>
					<svg
						width="24"
						height="24"
						className="mr-2"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M9.0185 4.66519C9.18499 3.16592 10.4564 2 12 2C13.5437 2 14.8151 3.16592 14.9816 4.6652C17.3554 5.78439 19 8.19905 19 11V14.1585C19 14.4321 19.1087 14.6945 19.3022 14.888L20.7071 16.2929C20.9931 16.5789 21.0787 17.009 20.9239 17.3827C20.7691 17.7564 20.4045 18 20 18L16 18C16 20.2091 14.2092 22 12 22C9.79089 22 8.00003 20.2091 8.00003 18L4.00003 18C3.59557 18 3.23093 17.7564 3.07615 17.3827C2.92137 17.009 3.00692 16.5789 3.29292 16.2929L4.69785 14.888C4.89133 14.6945 5.00003 14.4321 5.00003 14.1585V11C5.00003 8.19905 6.64464 5.78439 9.0185 4.66519ZM10 18C10 19.1046 10.8955 20 12 20C13.1046 20 14 19.1046 14 18H10ZM12 4C11.4477 4 11 4.44772 11 5V5.34142C11 5.76523 10.7329 6.14302 10.3333 6.28426C8.38994 6.97113 7.00003 8.82453 7.00003 11V14.1585C7.00003 14.8277 6.77872 15.4742 6.37664 16H17.6234C17.2213 15.4742 17 14.8277 17 14.1585V11C17 8.82453 15.6101 6.97113 13.6668 6.28426C13.2672 6.14302 13 5.76523 13 5.34142V5C13 4.44772 12.5523 4 12 4Z"
							fill="#004A99"
						></path>
					</svg>
					Notifications
				</a>
			) : (
				<button
					onClick={onNotificationsOpen}
					className="bg-sky-800 border border-sky-800 text-text-color-0 justify-center items-center gap-3 flex md:w-auto"
				>
					<svg
						width="24"
						height="24"
						className="mr-2"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M9.0185 4.66519C9.18499 3.16592 10.4564 2 12 2C13.5437 2 14.8151 3.16592 14.9816 4.6652C17.3554 5.78439 19 8.19905 19 11V14.1585C19 14.4321 19.1087 14.6945 19.3022 14.888L20.7071 16.2929C20.9931 16.5789 21.0787 17.009 20.9239 17.3827C20.7691 17.7564 20.4045 18 20 18L16 18C16 20.2091 14.2092 22 12 22C9.79089 22 8.00003 20.2091 8.00003 18L4.00003 18C3.59557 18 3.23093 17.7564 3.07615 17.3827C2.92137 17.009 3.00692 16.5789 3.29292 16.2929L4.69785 14.888C4.89133 14.6945 5.00003 14.4321 5.00003 14.1585V11C5.00003 8.19905 6.64464 5.78439 9.0185 4.66519ZM10 18C10 19.1046 10.8955 20 12 20C13.1046 20 14 19.1046 14 18H10ZM12 4C11.4477 4 11 4.44772 11 5V5.34142C11 5.76523 10.7329 6.14302 10.3333 6.28426C8.38994 6.97113 7.00003 8.82453 7.00003 11V14.1585C7.00003 14.8277 6.77872 15.4742 6.37664 16H17.6234C17.2213 15.4742 17 14.8277 17 14.1585V11C17 8.82453 15.6101 6.97113 13.6668 6.28426C13.2672 6.14302 13 5.76523 13 5.34142V5C13 4.44772 12.5523 4 12 4Z"
							fill="#fff"
						></path>
					</svg>
				</button>
			)}
			<Modal isOpen={modalVisibility} onClose={closeModal}>
				<div className="w-full">
					<div className="flex-col">
						<button
							className="close absolute right-0 cursor-pointer p-4 top-1 mt"
							onClick={closeModal}
						>
							<svg
								className="fill-current h-6 w-6 text-black"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 20 20"
							>
								<path d="M14.348 5.652a.5.5 0 10-.707-.707L10 9.293 5.359 4.652a.5.5 0 10-.707.707L9.293 10l-4.648 4.641a.5.5 0 00.707.707L10 10.707l4.641 4.648a.498.498 0 00.707 0 .5.5 0 000-.707L10.707 10l4.641-4.648z" />
							</svg>
						</button>

						<button onClick={backToMenuHandler} className="flex md:hidden py-5">
							<FontAwesomeIcon
								icon={faChevronLeft}
								className={
									'w-[14px] h-[14px] text-action-secondary-120 pt-1'
								}
							/>
							<span className="font-bold text-action-secondary-120 ml-2">
								BACK TO MENU
							</span>
						</button>
						<div className="flex text-sm lg:text-lg text-action-primary-blue-100 pb-4 font-bold pointer-events-auto">
							<svg
								width="24"
								height="24"
								className="mr-2"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M9.0185 4.66519C9.18499 3.16592 10.4564 2 12 2C13.5437 2 14.8151 3.16592 14.9816 4.6652C17.3554 5.78439 19 8.19905 19 11V14.1585C19 14.4321 19.1087 14.6945 19.3022 14.888L20.7071 16.2929C20.9931 16.5789 21.0787 17.009 20.9239 17.3827C20.7691 17.7564 20.4045 18 20 18L16 18C16 20.2091 14.2092 22 12 22C9.79089 22 8.00003 20.2091 8.00003 18L4.00003 18C3.59557 18 3.23093 17.7564 3.07615 17.3827C2.92137 17.009 3.00692 16.5789 3.29292 16.2929L4.69785 14.888C4.89133 14.6945 5.00003 14.4321 5.00003 14.1585V11C5.00003 8.19905 6.64464 5.78439 9.0185 4.66519ZM10 18C10 19.1046 10.8955 20 12 20C13.1046 20 14 19.1046 14 18H10ZM12 4C11.4477 4 11 4.44772 11 5V5.34142C11 5.76523 10.7329 6.14302 10.3333 6.28426C8.38994 6.97113 7.00003 8.82453 7.00003 11V14.1585C7.00003 14.8277 6.77872 15.4742 6.37664 16H17.6234C17.2213 15.4742 17 14.8277 17 14.1585V11C17 8.82453 15.6101 6.97113 13.6668 6.28426C13.2672 6.14302 13 5.76523 13 5.34142V5C13 4.44772 12.5523 4 12 4Z"
									fill="#004A99"
								></path>
							</svg>
							<p className="font-bold text-lg">Notifications</p>
						</div>
						{loading && (
							<div className="text-stone-700 text-base mt-3">
								Loading...
							</div>
						)}
						{!loading &&
							notifications &&
							notifications?.map((notification) => (
								<span key={notification.id}>
									<hr className="mb-1 bg-border/40 h-0.5 border-none"></hr>
									<div className="flex gap-4 py-1">
										<div className="mb-4 w-full text-stone-700 text-base mt-3">
											<p>{notification.description}</p>
											<a
												href={notification.url}
												className="flex gap-2"
											>
												<p className="font-bold">
													{notification.name}
												</p>
												<FontAwesomeIcon
													icon={faChevronRight}
													className={
														'w-[14px] h-[14px] text-action-secondary-120 pt-1'
													}
												/>
											</a>
										</div>
									</div>
								</span>
							))}
						{!loading && notifications?.length == 0 && (
							<div className="text-stone-700 text-base mt-3">
								No notifications
							</div>
						)}
					</div>
				</div>
			</Modal>
		</div>
	)
}
